import { createFileRoute } from '@tanstack/react-router'
import { PageShell } from '@/features/public-site/page-shell'
import { SimpleHero, HeroBadges, PricingCta } from '@/features/public-site/sections'

const clipExamples = [
  { title: '开场钩子', src: '/video/clip_hook.mp4', duration: '00:06' },
  { title: '核心观点', src: '/video/clip_core.mp4', duration: '00:08' },
  { title: '搞笑片段', src: '/video/clip_funny.mp4', duration: '00:07' },
  { title: '犀利观点', src: '/video/clip_point.mp4', duration: '00:14' },
  { title: 'CTA 时刻', src: '/video/clip_cta.mp4', duration: '00:14' },
]

export const Route = createFileRoute('/clipping')({
  component: ClippingPage,
})

function ClippingPage() {
  return (
    <PageShell>
      <SimpleHero
        eyebrow="AI 剪辑"
        title="用 AI 把长视频变成"
        highlighted="可编辑的短视频草稿"
        description="上传视频，AI 转录并识别高光片段，生成可编辑的短视频草稿项目。"
        buttonLabel="免费获取片段"
      />

      <HeroBadges
        items={[
          '高光识别',
          '自动转录',
          '可编辑草稿',
          '多比例输出',
        ]}
      />

      {/* Clip examples grid */}
      <section className="mx-auto mt-16 max-w-5xl px-4 sm:px-6">
        <div className="mb-6 text-center">
          <p className="text-sm font-medium uppercase tracking-[0.18em] text-primary">
            效果演示
          </p>
          <h2 className="mt-3 text-2xl font-bold text-foreground">
            一个广告视频，AI 切出 5 个片段
          </h2>
          <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
            以下片段由 JIAN 从一个 53 秒的商业广告中识别并切出。
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {clipExamples.map((clip) => (
            <div
              key={clip.title}
              className="overflow-hidden rounded-xl border border-border bg-card"
            >
              <video
                src={clip.src}
                controls
                preload="metadata"
                className="aspect-[9/16] w-full bg-black"
              />
              <div className="border-t border-border px-3 py-2">
                <div className="text-xs font-medium text-foreground">{clip.title}</div>
                <div className="mt-0.5 text-[11px] text-muted-foreground">{clip.duration}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <h2 className="text-2xl font-bold text-foreground">3 步生成短视频草稿</h2>
          <p className="mx-auto mt-3 max-w-md text-sm text-muted-foreground">
            上传视频，让 AI 转录并找出高光片段，审核后进入编辑器精修。
          </p>
        </div>
      </section>

      <PricingCta />
    </PageShell>
  )
}
